let _Symbol$iterator, _Symbol$toStringTag;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import cf from 'clownface';
import { rdf } from '@tpluscode/rdf-ns-builders';
import RDF from '@rdf-esm/data-model';
import { onlyUnique } from "./filter.mjs";
import * as compare from "./compare.mjs";

function getNode(value) {
  if (typeof value === 'string') {
    return RDF.namedNode(value);
  }

  if ('termType' in value) {
    return value;
  }

  return value.id;
}

_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
export default class {
  add(value) {
    this.__resource.pointer.addOut(rdf.type, getNode(value));

    return this;
  }

  clear() {
    this.__graph.deleteOut(rdf.type);
  }

  delete(value) {
    const deletedQuads = this.__graph.dataset.match(this.__resource.id, rdf.type, getNode(value));

    for (const quad of deletedQuads) {
      this.__graph.dataset.delete(quad);
    }

    return deletedQuads.size > 0;
  }

  forEach(callbackfn, thisArg) {
    for (const value of this.values()) {
      callbackfn.call(thisArg, value, value, this);
    }
  }

  has(value) {
    return this.__graph.has(rdf.type, getNode(value)).terms.length > 0;
  }

  get size() {
    return this.__graph.out(rdf.type).terms.filter(onlyUnique(compare.terms)).length;
  }

  [_Symbol$iterator]() {
    return this.values();
  }

  entries() {
    return this.__values.map(res => [res, res])[Symbol.iterator]();
  }

  keys() {
    return this.values();
  }

  values() {
    return this.__values[Symbol.iterator]();
  }

  constructor(resource, allGraphs = false) {
    _defineProperty(this, "__resource", void 0);

    _defineProperty(this, "__allGraphs", void 0);

    _defineProperty(this, "__graph", void 0);

    _defineProperty(this, _Symbol$toStringTag, void 0);

    this.__resource = resource;
    this.__allGraphs = allGraphs; // TODO: when clownface gets graph feature
    // this.__graph = allGraphs ? resource.pointer.fromUnionGraph() : resource.pointer

    this.__graph = allGraphs ? cf({
      dataset: resource.pointer.dataset,
      term: resource.pointer.term,
      graph: undefined
    }) : resource.pointer;
  }

  get __values() {
    const graphId = !this.__allGraphs ? this.__resource._graphId : null; // TODO: when clownface gets graph feature
    // const types: MultiPointer<Term, D> = this.__resource.pointer.from(graphId).out(rdf.type)

    const typeQuads = this.__graph.dataset.match(this.__resource.id, rdf.type, null, graphId);

    const types = [...typeQuads].map(quad => {
      return cf({
        dataset: this.__graph.dataset,
        term: quad.object,
        graph: quad.graph
      });
    });
    return types.map(type => this.__resource._create(type)).filter(onlyUnique(compare.resources(false)));
  }

}